import { isNumber } from "../../../utils"

export const black_color = "var(--lanzalake-black)"
export const grey_color = "var(--lanzalake-grey)"

export const getLabelTranslationFactor = (fontSize, tickFontSize, multiplier) => {
  const scaledFontSize = isNumber(fontSize) ? `${fontSize}px` : fontSize || "16px"
  const scaledTickSize = isNumber(tickFontSize) ? `${tickFontSize}px` : tickFontSize || "14px"
  const translate_factor = parseInt(scaledTickSize.split("px")[0]) * multiplier
  return [scaledFontSize, scaledTickSize, translate_factor]
}
